import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireRole } from '@/lib/auth/guards';

const WorkOrderDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.WorkOrderDetailPage })));
const DispatchPage = lazy(() => import('./dispatch-page').then((m) => ({ default: m.DispatchPage })));
const WorkOrderFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.WorkOrderFormPage })));
const WorkOrderListPage = lazy(() => import('./list-page').then((m) => ({ default: m.WorkOrderListPage })));

export const workOrderRoutes: RouteObject[] = [
  {
    path: 'work-orders',
    handle: { crumb: 'Work Orders' },
    children: [
      { index: true, element: <WorkOrderListPage /> },
      { path: 'new', element: <WorkOrderFormPage />, handle: { crumb: 'New work order' } },
      { path: ':id', element: <WorkOrderDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Work order' } },
    ],
  },
  { element: <RequireRole roles={['admin']} />, children: [{ path: 'dispatch', element: <DispatchPage />, handle: { crumb: 'Dispatch' } }] },
];
